import { api } from "../api";
import { CommandQueueType } from "../../../types/types";

/**
 * commandQueueFindAllByDeviceId - Function that finds on database all queued commands by deviceId  
 * /commands/queue/{deviceId}      
 * method GET 
 * @async-function
 */
const commandQueueFindAllByDeviceId = async (token: string, deviceId: number) => {
    const response = await api.get<Array<CommandQueueType>>(
        `/commands/queue/${deviceId}`, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        }
    );
    return response;
};

export default commandQueueFindAllByDeviceId;
